import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addLeadStatus, getLeadStatus, updateLeadStatus, deleteLeadStatus } from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class LeadStatus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            leadstatus: ''
        }
        this.handleLeadStatusSubmit = this.handleLeadStatusSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (leadstatus) => {
        this.setState({ leadstatus: leadstatus });
        this.setState({ deleteModal: true });
    };

    handleDeleteLeadStatus = () => {
        const { onDeleteLeadStatus } = this.props;
        const { leadstatus } = this.state;

        if (leadstatus.id !== undefined) {
            onDeleteLeadStatus(leadstatus);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleLeadStatusSubmit(value) {
        this.props.addLeadStatus(value, this.props.history);
    }

    componentDidMount() {
        const { onGetLeadStatus } = this.props;
        onGetLeadStatus(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { leadstatuses } = this.props;
        if (!isEmpty(leadstatuses) && size(prevProps.leadstatuses) !== size(leadstatuses)) {
            this.setState({ leadstatuses: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ leadstatus: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const leadstatus = arg;
        this.setState({
            leadstatus: {
                id: leadstatus.id,
                leadStatusId: leadstatus.leadStatusId,
                leadStatusTitle: leadstatus.leadStatusTitle,
                agentId: leadstatus.agentId
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { leadstatuses, onUpdateAppLeadStatus } = this.props;
        const { isEdit, deleteModal } = this.state;
        const leadstatus = this.state.leadstatus;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteLeadStatus}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Lead Status")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        leadStatusTitle: (this.state && this.state.leadStatusTitle) || "",

                                    }}
                                    validationSchema={Yup.object().shape({
                                        leadStatusTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleLeadStatusSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Lead Status</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="leadStatusTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="leadStatusTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.leadStatusTitle && touched.leadStatusTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="leadStatusTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="leadStatusTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(leadstatuses, (leadstatus, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{leadstatus.leadStatusTitle}</td>
                                                                        <td>
                                                                                 {leadstatus.agentId > 0 ? (
                                                                            <>
                                                                              <ActionEdit onClick={() => this.toggleRightCanvas(leadstatus)} />
                                                                                                                                                                                                                                
                                                                            <ActionDelete onClick={() => this.onClickDelete(leadstatus)} />
                                                                          </>
                                                                        ) : null}

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: leadstatus.id,
                                        leadStatusId: leadstatus.leadStatusId,
                                        leadStatusTitle: leadstatus.leadStatusTitle,
                                        agentId: leadstatus.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        leadStatusTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                leadStatusId: values.leadStatusId,
                                                leadStatusTitle: values.leadStatusTitle,
                                                agentId: values.agentId
                                            };
                                            onUpdateAppLeadStatus(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="leadStatusTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="leadStatusTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.leadStatusTitle && touched.leadStatusTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="leadStatusTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="leadStatusTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
LeadStatus.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addLeadStatus: PropTypes.func,
    onGetLeadStatus: PropTypes.func,
    leadstatuses: PropTypes.array,
    onDeleteLeadStatus: PropTypes.func,
    onUpdateAppLeadStatus: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        leadstatuses: AppoinmentObject.leadstatuses,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addLeadStatus: (data) => dispatch(addLeadStatus(data)),
    onGetLeadStatus: (agentId) => dispatch(getLeadStatus(agentId)),
    onDeleteLeadStatus: (id) => dispatch(deleteLeadStatus(id)),
    onUpdateAppLeadStatus: (data) => dispatch(updateLeadStatus(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LeadStatus))
